export enum PROJECT_STAGE_UUID {
	'5038a0c7-500a-4eee-8ab4-236fa636fb55' = 'Awarded',
	'ad869dd5-52bc-44f6-8ef6-6bdf41b7dc22' = 'On Hold',
	'b4bccac6-5ac9-451e-9d68-f235f0e3fd49' = 'Re Bid',
	'de189832-5dc1-44f8-8121-e1f3ed725378' = 'New',
	'fa486cf3-7cae-4d21-81ee-64d85f769a1d' = 'Live',
	'3380b684-1b5c-4200-8c21-c7e6af65cdce' = 'Submitted',
}

export const PROJECT_STAGE_UUID_MAP = {
	AWARDED: '5038a0c7-500a-4eee-8ab4-236fa636fb55',
	ON_HOLD: 'ad869dd5-52bc-44f6-8ef6-6bdf41b7dc22',
	RE_BID: 'b4bccac6-5ac9-451e-9d68-f235f0e3fd49',
	NEW: 'de189832-5dc1-44f8-8121-e1f3ed725378',
	LIVE: 'fa486cf3-7cae-4d21-81ee-64d85f769a1d',
	SUBMITTED: '3380b684-1b5c-4200-8c21-c7e6af65cdce',
};
